import { IFieldMenuAction } from '@/fields/context-menu/types/field-menu-action';
import { EFieldMenuActionType } from '@/fields/context-menu/types/enums/field-menu-action-type';

export const multipleFieldActionsBase: IFieldMenuAction[] = [
  {
    name: 'text-size',
    type: EFieldMenuActionType.TextSize,
    icon: 'text-size-icon',
  },
  {
    name: 'recipients',
    type: EFieldMenuActionType.Recipients,
    icon: 'connect-field',
  },
  {
    name: 'move-field-to-other-page',
    type: EFieldMenuActionType.Move,
    icon: 'move-to-page',
  },
  {
    name: 'align-fields',
    type: EFieldMenuActionType.Align,
    icon: 'align-vertical-center',
  },
  {
    name: 'duplicate',
    type: EFieldMenuActionType.Duplicate,
    icon: 'duplicate',
  },
  {
    name: 'Delete',
    type: EFieldMenuActionType.Delete,
    icon: 'delete',
  },
];

export const singleFieldActionsBase: IFieldMenuAction[] = [
  {
    name: 'settings',
    type: EFieldMenuActionType.Settings,
    icon: 'settings',
  },
  {
    name: 'recipients',
    type: EFieldMenuActionType.Recipients,
    icon: 'connect-field',
  },
  {
    name: 'duplicate',
    type: EFieldMenuActionType.Duplicate,
    icon: 'duplicate',
  },
  {
    name: 'move-field-to-other-page',
    type: EFieldMenuActionType.Move,
    icon: 'move-to-page',
  },
  {
    name: 'text-size',
    type: EFieldMenuActionType.TextSize,
    icon: 'text-size-icon',
  },
  {
    name: 'Delete',
    type: EFieldMenuActionType.Delete,
    icon: 'delete',
  },
];
